export default __webpack_public_path__ + "static/media/repeat.1e76e894.svg";